"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInvitePending = isInvitePending;
function isInvitePending(user) {
    return user.auth0UserId !== null && !user.emailConfirmed;
}
//# sourceMappingURL=invite-state.js.map